module.exports = __webpack_public_path__ + "img/ajuda.f4583bfd.svg";